.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.form-subtitle {
  margin-top: calc(var(--spacer) * 4);
  margin-bottom: calc(var(--spacer));
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

.infoText {
  color: var(--body-text-arrows-400);
}

gz-dropdown {
  --form-field-input-width: 400px;
}

gz-text + gz-form-field {
  margin-top: calc(var(--spacer) * 2.5);
}

gz-info-box {
  padding-left: calc(var(--spacer) * -1);
}

gz-form-field[searchable-label] {
  --margin-bottom-wrapper: 0px;
  margin-bottom: calc(var(--spacer) * 2);
  width: fit-content;
}
